export default __webpack_public_path__ + "static/containerization_tab_image-18bfb34757e14ce1c70c09b367d9f819.svg";